import { Box, Flex, ReadonlyField, Text } from '@shared/components';

import ReadonlyBooleanRadio from '../readonly-form-boolean-radio/readonly-form-boolean-radio';
import { ReadonlyFormImagesInput } from '../readonly-form-images-input';

interface PhysicalInfoFeatureCheckRowProps {
  label: string;
  value: boolean | null;
  required: boolean;
  additionalInfo: string;
  images: string[] | null;
  isReadonly?: boolean;
  hasImages: boolean;
  imageHelperText?: string;
}

export default function ReadonlyPhysicalInfoFeatureCheckRow(
  props: PhysicalInfoFeatureCheckRowProps,
) {
  const { label, required, value, additionalInfo, hasImages, images, imageHelperText } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'row',
        gap: theme.spacing(6),
        justifyContent: 'space-between',
        [theme.breakpoints.down('desktop')]: {
          flexDirection: 'column',
          gap: theme.spacing(2),
        },
      })}
    >
      <Box sx={{ width: '320px' }}>
        <Text variant='body1Semibold' sx={{ whiteSpace: 'nowrap' }}>
          {label}
          {required ? (
            <Text
              component='span'
              sx={(theme) => ({ marginLeft: theme.spacing(1) })}
              color='error.main'
            >
              *
            </Text>
          ) : null}
        </Text>
      </Box>
      <Flex
        sx={(theme) => ({
          flex: 1,
          flexDirection: 'column',
          gap: theme.spacing(4.5),
        })}
      >
        <ReadonlyBooleanRadio value={value ?? false} />
        <ReadonlyField content={additionalInfo ?? '-'} />
        {hasImages ? (
          <ReadonlyFormImagesInput images={images ?? []} label={imageHelperText} />
        ) : null}
      </Flex>
    </Flex>
  );
}
